import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MomMinutesOfMeetingService } from 'src/app/services/mom-minutes-of-meeting.service';

@Component({
  selector: 'app-mom-meeting-type-update',
  templateUrl: './mom-meeting-type-update.component.html',
  styleUrls: ['./mom-meeting-type-update.component.scss']
})
export class MomMeetingTypeUpdateComponent implements OnInit {
  mode:any
  addMeetingTypeForm: FormGroup = new FormGroup({});
  meetingTypeId:any
  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private router: Router,
    private momMinutesOfMeetingService: MomMinutesOfMeetingService, private dialog: MatDialog
  ){
    console.log(activatedRoute.params, )
    
  }
  
  ngOnInit() {
    this.activatedRoute.params.subscribe((res:any)=>{
      this.mode = res.mode
      this.meetingTypeId = res.id
      console.log(this.mode, res.id)
      this.getMeetingTypeById(this.meetingTypeId)
    })
  
    this.addMeetingTypeForm = new FormGroup({
      id: new FormControl(1, [Validators.required]),
      meetingType: new FormControl("Test", [Validators.required]),
    });
    
  }

  getMeetingTypeById(meetingTypeId:number){
    this.momMinutesOfMeetingService.getMeetingTypeById(meetingTypeId)
    .subscribe((res:any)=>{
      console.log(res)
      if(res.id){
        this.addMeetingTypeForm.patchValue({
          id: res.id,
          meetingType: res.meetingType
        });
      }
    })
  }

  updateMeetingType(){
    // let body = {
    //   id: this.addMeetingTypeForm.value.id,
    //   boardName: this.addMeetingTypeForm.value.boardName
    // }
    console.log(this.addMeetingTypeForm.value);
    if(this.addMeetingTypeForm.valid) {
      this.momMinutesOfMeetingService.updateMeetingType(this.addMeetingTypeForm.value)
      .subscribe((res:any)=>{
        if(res.id){
          this.addMeetingTypeForm.reset()
          this.momMinutesOfMeetingService.successToast('Meeting Type updated Successfully')
          this.goBack()
        }else{
          this.momMinutesOfMeetingService.errorToast("Error Occured")
        }
      })
      this.dialog.closeAll()
    }
    else {
      this.momMinutesOfMeetingService.errorToast('Please enter Meeting type');
    }
  }

  goBack(){
    this.router.navigate(['/secure/mom-meeting-type/view', 'view'])
  }

  opneConfirmationModal(templateRef: TemplateRef<any>){
    console.log(this.addMeetingTypeForm.value);
    this.dialog.open(templateRef, {
      width: '30%',
      // height: '15%',
      hasBackdrop: false
    })
  }

  cancel() {
    this.dialog.closeAll();
  }

  

}
